import React from "react";
import MarketingNav from "@/components/MarketingNav";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login, loading, user } = useAuth();

  // If already signed in, bounce straight to the dashboard.
  React.useEffect(() => {
    if (!loading && user) {
      window.location.replace("/dashboard");
    }
  }, [loading, user]);

  const handleLogin = () => {
    // login() uses Auth0 loginWithRedirect under the hood. The Auth0
    // provider builds redirect_uri from window.location.origin at runtime
    // (see /app/frontend/src/lib/auth0Provider.jsx).
    login("/dashboard");
  };

  return (
    <div className="bg-white min-h-screen" data-testid="login-page">
      <MarketingNav />
      <section className="max-w-lg mx-auto px-6 py-20 lg:py-28">
        <div className="label-eyebrow">Sign in</div>
        <h1 className="display mt-2 text-4xl sm:text-5xl font-black tracking-tighter">
          Welcome back.
        </h1>
        <p className="mt-3 text-zinc-600 text-sm">
          Sign in with your email or Google. Your session is encrypted and
          token-based — no passwords stored on our servers.
        </p>

        <div className="card-flat mt-10 p-6">
          <button
            onClick={handleLogin}
            data-testid="auth0-signin-button"
            className="w-full inline-flex items-center justify-center gap-2 bg-black text-white text-sm px-4 py-3 rounded-[4px] hover:bg-zinc-800 transition-colors"
          >
            Sign in / Sign up <ArrowRight size={14} />
          </button>
          <div className="mt-4 label-eyebrow">What happens next</div>
          <ol className="mt-2 space-y-1.5 text-xs text-zinc-600 mono">
            <li>01 You're sent to Auth0 Universal Login</li>
            <li>02 Choose email + password or Google</li>
            <li>03 We create your AnswerWatch account on first sign-in</li>
            <li>04 You land on the dashboard</li>
          </ol>
        </div>

        <div className="mt-6 text-xs text-zinc-500">
          By continuing you agree to the Terms &amp; Privacy Policy. We never
          share your data.
        </div>
      </section>
    </div>
  );
}
